import { render, staticRenderFns } from "./DeviceRegistration.vue?vue&type=template&id=5f839000&scoped=true&"
import script from "./DeviceRegistration.vue?vue&type=script&lang=js&"
export * from "./DeviceRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f839000",
  null
  
)

export default component.exports